import styled from 'styled-components'

import { Colors } from '@fourthwall/components'

export const Container = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 150%; /* 21px */
  letter-spacing: 0.14px;
  color: ${Colors.GS600};
`

export const Icon = styled.div`
  width: 14px;
  height: 14px;
  margin-right: 12px;
  display: inline-block;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`

export const Label = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
`
